import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { useApp } from "@/lib/app-context";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ROLE_LABEL = { admin: "Owner (admin)", manager: "Manager – can edit", staff: "Staff – view only", pending: "No access" };

export default function UsersPage() {
  const { api, me } = useApp();
  const [data, setData] = useState({ roles: [], users: [] });

  const load = useCallback(async () => setData(await api("get", "/users")), [api]);
  useEffect(() => { load(); }, [load]);

  const change = async (uid, role) => {
    try {
      await api("patch", `/users/${uid}/role`, { role });
      toast.success("Access updated");
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not update");
    }
  };

  return (
    <div className="space-y-6 fade-up" data-testid="users-page">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-extrabold tracking-tight">Logins</h1>
        <p className="text-sm text-slate-600 mt-1">Anyone who signs up starts with no access. Give your staff access here.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-xl divide-y">
        {data.users.map((u) => (
          <div key={u.user_id} className="flex flex-col sm:flex-row sm:items-center gap-3 p-4" data-testid={`user-row-${u.user_id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-semibold truncate">{u.name || u.email || u.user_id}</div>
              <div className="text-xs text-slate-500 truncate">{u.email}{u.user_id === me.user_id ? " · you" : ""}</div>
            </div>
            <Select value={u.role} onValueChange={(r) => change(u.user_id, r)}>
              <SelectTrigger className="w-full sm:w-52" data-testid={`user-role-select-${u.user_id}`}><SelectValue /></SelectTrigger>
              <SelectContent>
                {data.roles.map((r) => <SelectItem key={r} value={r}>{ROLE_LABEL[r] || r}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </div>
  );
}
